import { isShallowEqual } from "@suse-o11y/is-shallow-equal";
import { prop } from "@suse-o11y/prop";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { selectTimeRange, selectTimestampDate } from "../../../app/state/view/timeline/TimelineSelectors";
import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";
import { useCurrentView, useQueryToExecute } from "../../../app/state/view/viewpoint/ViewPointHooks";
import type { EventCategory } from "../../../common/openapi";

import { toEventCategory } from "./EventPerspectiveUtils";

export interface EventPerspectiveProps {
	timeRange: TimeRange;
	topologyQuery: string;
	selectedTimestamp: number | undefined;
	eventTypes: Array<string>;
	eventTags: Array<string>;
	eventCategories: Array<EventCategory>;
	eventSources: Array<string>;
}

export const useEventPerspectiveProps = (): EventPerspectiveProps => {
	const eventFilters = useCurrentView().transform(prop("eventFilters")).getOrElse(undefined);
	const topologyQuery = useQueryToExecute().getOrElse("");

	const timeRange = useSelector(selectTimeRange, isShallowEqual);
	const timestamp = useSelector(selectTimestampDate, isShallowEqual)?.valueOf();

	return useMemo(
		() => ({
			timeRange,
			topologyQuery,
			selectedTimestamp: timestamp,
			eventTags: eventFilters?.tags ?? [],
			eventTypes: eventFilters?.types ?? [],
			eventCategories: eventFilters?.categories?.map(toEventCategory) ?? [],
			eventSources: eventFilters?.sources ?? [],
		}),
		[timeRange, timestamp, topologyQuery, eventFilters],
	);
};
